<template>
  <a-layout-content class="ehf-content" :class="{ modalPage, hidden }">
    <router-view v-slot="{ Component }" v-if="!isReload">
      <component :is="Component" />
    </router-view>
  </a-layout-content>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'EhfContent',
    provide() {
      // 提供给其他组件使用
      return {
        reload: this.reload,
      }
    },
    data() {
      return {
        isReload: false,
      }
    },
    methods: {
      // 刷新router-view
      reload() {
        this.isReload = true
        this.$nextTick(() => {
          this.isReload = false
        })
      },
    },
    computed: {
      ...mapGetters({
        hidden: 'settings/hidden',
      }),
      modalPage() {
        return this.$route.meta.modalPage
      },
    },
  }
</script>

<style lang="scss">
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all 0.2s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  .ehf-content {
    position: relative;
    min-height: calc(100vh - #{$ehf-header-height} - #{$ehf-margin} - #{$ehf-margin}) !important;
    padding: 0;
    margin: $ehf-margin;
    background: #fff;
    &.hidden {
      min-height: calc(100vh - #{$ehf-margin} - #{$ehf-margin}) !important;
    }
    .error-container {
      height: calc(100vh - #{$ehf-header-height} - #{$ehf-margin} - #{$ehf-margin}) !important;
    }
  }

  .ehf-content.modalPage {
    min-height: 100vh !important;
    margin: 0;
  }
</style>
